import React from 'react';
import { cn } from '@/lib/utils';
import { confidenceColorClasses, badgeBase } from './ConfidenceBadge.styles';
import type { ConfidenceBadgeProps } from './ConfidenceBadge.types';

export const ConfidenceBadge: React.FC<ConfidenceBadgeProps> = ({ confidence }) => {
  if (confidence === null || confidence === undefined) {
    return <span className="text-slate-400 text-xs">—</span>;
  }

  const pct = Math.round(confidence * 100);
  const colorClass =
    pct >= 80
      ? confidenceColorClasses.high
      : pct >= 60
        ? confidenceColorClasses.medium
        : confidenceColorClasses.low;

  return (
    <span className={cn(badgeBase, colorClass)}>
      {pct}%
    </span>
  );
};
